<!--
 * @Author: your name
 * @Date: 2021-07-07 14:40:40
 * @LastEditTime: 2021-07-07 16:53:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \topboomadmin\src\views\spike\List.vue
-->
<template>
  <div class="content">
    <el-form inline>
      <el-form-item label="商品名称：">
        <el-input placeholder="请输入"
                  v-model="search.name"></el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select v-model="search.status"
                   placeholder="">
          <el-option :value="-1"
                     label="全部">
          </el-option>
          <el-option :value="1"
                     label="进行中">
          </el-option>
          <el-option :value="2"
                     label="即将开始">
          </el-option>
          <el-option :value="3"
                     label="已过期">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="getList">搜索</el-button>
        <el-button type="primary"
                   @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="add">
      <el-button class="tb-button"
                 type="primary"
                 @click="add">
        <i class="tb-icon-plus" />新增秒杀商品
      </el-button>
    </div>
    <el-table :data="list"
              style="width: 100%"
              class="tb-table">
      <el-table-column prop="id"
                       label="秒杀ID"
                       width="width">
      </el-table-column>
      <el-table-column prop="product_name"
                       label="商品名称"
                       width="width">
      </el-table-column>
      <el-table-column label="秒杀时间段"
                       width="width">
        <template slot-scope="scope">
          {{scope.row.start_time + '-' + scope.row.end_time}}
        </template>
      </el-table-column>
      <el-table-column prop="status_name"
                       label="状态"
                       width="width">
      </el-table-column>
      <el-table-column label="操作"
                       width="width">
        <template slot-scope="scope">
          <span class="edit"
                @click="toDetail(scope.row)">编辑</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background
                   class="tb-pagination"
                   @size-change="sizeChange"
                   layout="prev, pager, next, sizes"
                   :current-page="page.no + 1"
                   :page-sizes="[10,20,50,100]"
                   :page-size="page.size"
                   :total="page.total"
                   @current-change="pageChange" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      search: {
        name: '',
        status: -1
      },
      page: {
        no: 0,
        size: 10,
        total: 0
      }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    add () {
      this.toDetail(null)
    },
    reset () {
      this.search.name = ''
      this.search.status = -1
      this.page.no = 0
      this.getList()
    },
    getList () {
      let params = { page_no: this.page.no, page_size: this.page.size }
      params = Object.assign(params, this.search)
      const url = 'admin/spike/list'
      this.$https.get(url, { params }).then((result) => {
        if (result) {
          this.list = result.list
          this.page.total = result.total_count
        }
      })
    },
    toDetail (row) {
      if (null === row) {
        this.$router.push('/spike/detail')
      } else {
        this.$router.push('/spike/detail?id=' + row.id)
      }
    },
    pageChange (no) {
      this.page.no = no - 1
      this.getList()
    },
    sizeChange (val) {
      this.page.no = 0
      this.page.size = val
      this.getList()
    }
  }
}
</script>